import { FamilyRestroomRounded } from "@mui/icons-material";

export const ROUTES = {
  HOME: { path: '/', public: true },
  LOGIN: { path: '/login', public: true },
  SIGNUP: { path: '/signup', public: true },
  CHECK_EMAIL: { path: '/check-email', public: true },
  VERIFY_EMAIL: { path: '/verify-email', public: true },
  FORGOT_PASSWORD: { path: '/forgot-password', public: true },
  RESET_PASSWORD: { path: '/reset-password', public: true },
  GMAIL_CALLBACK: { path: '/auth/google/callback', public: false },
  DASHBOARD: { path: '/dashboard', public: false },
  EXPLAINER: { path: '/dashboard/explainer', public: false }, // Added for new menu item
  INTERVIEW_PREP: { path: '/dashboard/interview-prep', public: false }, // Added for new menu item
  OUTREACH: { path: '/dashboard/outreach', public: false },
  OUTREACH_CAMPAIGN: { path: '/dashboard/outreach/:id', public: false },
  PODCAST_SEARCH: { path: '/dashboard/podcasts', public: false },
  PODCAST_DETAILS: { path: '/dashboard/podcasts/:id', public: false },
  SETTINGS: { path: '/dashboard/settings', public: false },
  CREDITS: { path: '/dashboard/credits', public: false },
  PRICING: { path: '/dashboard/pricing', public: false },
  PAYMENT_SUCCESS: { path: '/payment/checkout/success', public: true },
  TERMS: { path: '/terms', public: true },
  PRIVACY: { path: '/privacy', public: true },
  CONTACT: { path: '/contact', public: true },
  ADMIN: { path: '/admin', public: FamilyRestroomRounded },
  NOT_FOUND: { path: '*', public: true }
};
